import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { ErrorState } from '@/shared/components/ErrorState'
import { SystemStateIllustration } from '@/shared/components/illustrations/SystemStateIllustration'
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle'

export function RouteErrorPage() {
  const { t } = useTranslation()
  useDocumentTitle(t('ui.route_error.page_title'))

  return (
    <ErrorState
      title={t('ui.route_error.title')}
      description={t('ui.route_error.description')}
      retryLabel={t('ui.route_error.retry')}
      onRetry={() => window.location.reload()}
    >
      <SystemStateIllustration variant="error" className="mt-2 mb-4" />
      <p className="mt-4 text-sm">
        <Link to="/" className="text-primary underline underline-offset-4">
          {t('ui.route_error.home')}
        </Link>
        {' · '}
        <Link to="/faq" className="text-primary underline underline-offset-4">
          {t('ui.route_error.support')}
        </Link>
      </p>
    </ErrorState>
  )
}
